import { Checkbox, FormControl, FormControlLabel, FormGroup } from '@material-ui/core'
import { withStyles } from '@material-ui/styles'
import PropTypes from 'prop-types'
import { compose } from 'ramda'
import React from 'react'
import { ensureFunction } from 'app/utils/fp'
import Text from 'core/elements/Text'
import { memoize } from 'utils/misc'

const styles = (theme) => ({
  root: {
    padding: '16px 24px 16px 24px',
    fontFamily: 'Roboto',
  },
  title: {
    marginLeft: -7,
    fontSize: '14px',
    color: theme?.components?.typography?.default,
    textAlign: 'left',
    fontWeight: 500,
  },
  formGroup: {
    marginTop: 8,
  },
  formControl: {},
  checkbox: {
    padding: 0,
    width: 32,
    height: 32,
  },
  checkboxRoot: {
    '&$checked': {
      color: theme?.components?.checkbox?.selectedBackground,
    },
  },
  checked: {},
  label: {
    fontSize: 15,
    marginLeft: '8px',
    color: theme?.components?.typography?.default,
  },
})

class ListTableColumnPopover extends React.PureComponent {
  handleColChange = memoize((columnId) => (e) => {
    ensureFunction(this.props.onColumnToggle)(columnId)
  })

  render() {
    const { classes, columns, visibleColumns } = this.props
    return (
      <FormControl component="fieldset" className={classes.root} aria-label="Columns">
        <Text variant="caption1" className={classes.title}>
          Columns
        </Text>
        <FormGroup className={classes.formGroup}>
          {columns
            .filter((column) => column.excluded !== true)
            .map((column) => (
              <FormControlLabel
                key={column.id}
                classes={{
                  root: classes.formControl,
                  label: classes.label,
                }}
                label={column.label}
                control={
                  <Checkbox
                    className={classes.checkbox}
                    classes={{
                      root: classes.checkboxRoot,
                      checked: classes.checked,
                    }}
                    onChange={this.handleColChange(column.id)}
                    checked={visibleColumns.includes(column.id)}
                    value={column.label}
                  />
                }
              />
            ))}
        </FormGroup>
      </FormControl>
    )
  }
}

ListTableColumnPopover.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      display: PropTypes.bool,
      excluded: PropTypes.bool,
    }),
  ).isRequired,
  visibleColumns: PropTypes.array,
  onColumnToggle: PropTypes.func,
  classes: PropTypes.object,
}

export default compose(withStyles(styles))(ListTableColumnPopover)
